import React from 'react';
import ReactDOM from 'react-dom';
import OfflineUserModal from './offlineUserModal';
import ProtocolModal from './protocolModal';
import { getURLSearchObj } from "@ali/abf-base";

export const env = getURLSearchObj().env || window['pageVars']?.app?.env || '';

export const toDataURL = (chart) => {
  let dataURL = '';
  if (chart) {
    let canvas: any = null
    if (typeof chart.get === 'function') {
      canvas = chart.get('canvas')
    } else {
      canvas = chart.getCanvas();
    }
    const canvasDom = canvas.get('el');
    if (canvasDom) {
      dataURL = canvasDom.toDataURL('image/png');
    }
  }
  return dataURL;
}

export const renderNode = (node) => {
  const div = document.createElement('div')
  div.style.position = 'absolute'
  div.style.top = '-1000000px'
  div.style.left = '-1000000px'
  document.body.appendChild(div)

  ReactDOM.render(<>
    {node}
  </>, div);

  return () => {
    document.body.removeChild(div)
  }
}

export const openPage = (url) => {
  const a = document.createElement('a');
  a.target = '_blank'
  a.href = url
  a.click()
  setTimeout(() => {
    a.parentNode?.removeChild(a)
  }, 0)
}

export const hostMap = {
  prod: 'https://service.kyxingyuan.com',
  pre: "https://pre-service.kyxingyuan.com",
  // pre: "https://pre-xingyuan.youku.com",
  // daily: 'http://xingyuan.alibaba.net',
  // daily: "https://pre-xingyuan.youku.com",
  daily: "",
};

export const getHost = () => {
  if (env === 'prod') {
    return hostMap.prod
  } else if (env === 'pre') {
    return hostMap.pre
  } else {
    return hostMap.daily
  }
}

export const getLogoutUrl = () => {
  if (env === 'prod') {
    return 'https://service.kyxingyuan.com/logout'
  } else if (env === 'pre') {
    return 'https://pre-service.kyxingyuan.com/logout'
  } else {
    return 'https://pre-service.kyxingyuan.com/logout'
  }
}

export const goLogout = () => {
  window.location.href = getLogoutUrl()
}

export const goLogin = () => {
  if (env === 'prod') {
    window.location.href = `https://service.kyxingyuan.com/login?backUrl=${window.location.href}`
  } else if (env === 'pre') {
    window.location.href = `https://pre-service.kyxingyuan.com/login?backUrl=${window.location.href}`
  } else {
    window.location.href = `https://pre-service.kyxingyuan.com/login?backUrl=${window.location.href}`
  }
}

let hasOfflineUserModal = false
export const offlineUser = () => {
  if (hasOfflineUserModal) {
    return
  }
  hasOfflineUserModal = true
  const iframe = document.createElement('iframe')
  iframe.style.width = '0px'
  iframe.style.height = '0px'
  iframe.style.display = 'none'
  // iframe.src = _window.logoutUrl
  iframe.src = 'https://mozi-login.alibaba-inc.com/ssoLogout.htm?APP_NAME=yk-xingyuan'
  document.body.appendChild(iframe)
  ReactDOM.render(<OfflineUserModal />, document.getElementById('star-offline-iframe'));
}

export const showProtocol = () => {
  let key = ''
  const arr = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0']
  for (let i = 0; i < 16; i++) {
    key += arr[parseInt(Math.random() * arr.length + '', 10)]
  }
  ReactDOM.render(<ProtocolModal key={key} />, document.getElementById('star-protocol'));
}

export const requestCtrl = (data) => {
  if (!data) {
    throw new Error("系统繁忙，请稍后再试");
  }
  if (data.status === -2) {
    goLogin()
  } else if (data.status === -7) {
    offlineUser()
  } else if (data.status !== 0) {
    throw new Error(data.msg ? `${data.msg}[${data.status}]` : `系统繁忙，请稍后再试${data.status ? `[${data.status}]` : ''}`);
  }
  return data
}